import {
    REQUEST_DELETE_USER,
    REQUEST_DELETE_USER_FAILURE,
    REQUEST_DELETE_USER_SUCCESS
} from "../../constant/UsersConstant";

const initialState = {
    deleteUser: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const deleteUserReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_DELETE_USER:
            return {
                ...state,
                deleteUser: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_DELETE_USER_SUCCESS:
            return {
                ...state,
                deleteUser: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_DELETE_USER_FAILURE:
            return {
                ...state,
                deleteUser: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
